import { render, staticRenderFns } from "./SpSevenModuleMore.vue?vue&type=template&id=66ce8b6a&scoped=true"
import script from "./SpSevenModuleMore.vue?vue&type=script&lang=js"
export * from "./SpSevenModuleMore.vue?vue&type=script&lang=js"
import style0 from "./SpSevenModuleMore.vue?vue&type=style&index=0&id=66ce8b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ce8b6a",
  null
  
)

export default component.exports